export const HOME_PAGE_MODAL = {
  NULL: null,
  TRANSACTION_SUCCESS: 'transaction-success',
};
